import React from "react";
import { useTranslation } from "react-i18next";

import { DeveloperLnkPublisherState, GamePublisherState } from "@/const";
import { Awesome } from "@components/Helpers";

export function PublisherStateDisplay({ publisher }) {
    const { t } = useTranslation();

    switch (publisher.state) {
        case GamePublisherState.ON_MODERATION:
            return <Awesome type="hourglass-half" color="orange" tooltip={t("На модерации")} />;
        case GamePublisherState.APPROVED:
            return <Awesome type="thumbs-up" color="green" tooltip={t("Одобрен")} />;
        case GamePublisherState.REJECTED:
            return <Awesome type="thumbs-down" color="red" tooltip={t("Отклонен")} />;
        default:
            return null;
    }
}

export function DeveloperLnkPublisherStateDisplay({ lnk }) {
    const { t } = useTranslation();

    switch (lnk.state) {
        case DeveloperLnkPublisherState.ON_MODERATION:
            return <Awesome type="hourglass-half" color="orange" tooltip={t("На модерации")} />;
        case DeveloperLnkPublisherState.APPROVED:
            return <Awesome type="thumbs-up" color="green" tooltip={t("Одобрен")} />;
        case DeveloperLnkPublisherState.REJECTED:
            return <Awesome type="thumbs-down" color="red" tooltip={lnk.moder_comment} />;
        default:
            return null;
    }
}
